<template>
    <div :class="{
                'relative z-10': $route.path == '/dashboard'
            }">
        <div v-if="isShowHeader" class="laptop:w-fit laptop:h-[55px] p-3 rounded-[10px] mx-[16px] laptop:mx-auto text-center flex justify-center items-start 
            laptop:items-center gap-2.5 bg-[#FF00041A]/10 border-[1px] !border-[#FF000480]/50" :class="{
                '!bg-[#fde2d9]': $route.path == '/dashboard'
            }">
            <!-- <img src="../../assets/images/warn-icon.png" alt="Body Bg"
                class="w-[20px] laptop:w-[22px] h-[20px] laptop:h-[22px] mobile:hidden laptop:block object-cover"> -->
                
            <p class="m-0 text-xs tablet:text-base font-roboto font-medium text-left !leading-[1.2]">
                You have an outstanding invoice balance of
                <strong>{{ failedInvoices.total_amount_formatted }}</strong>.
                <a @click="payOutstandingInvoice" class="text-blue-600 underline cursor-pointer">
                    Click here
                </a>
                to pay now and avoid any interruption to your service.
            </p>
        </div>
    </div>
    <processFailedModal ref="processFailedModal" :refresh="refreshList" />

</template>

<script>
import { Modal } from "bootstrap";
import {
    mapGetters, mapActions
} from "vuex";
import processFailedModal from "../../components/cancelClaim/processFailedModal.vue";

export default {
    components: {
        processFailedModal

    },
    computed: {
        ...mapGetters([
            "failedInvoices", "paymentCollectResponse","paymentCollectFailResponse"
        ]),
    },
    data() {
        return {
            isShowHeader: false
        };
    },

    mounted() {
        this.getFailedInvoices({})
    },

    watch: {

        paymentCollectFailResponse: function (data) {
            if (this.paymentCollectFailResponse.length > 0) {
                this.getFailedInvoices({})
            }
        },

        failedInvoices: function (data) {


            if (this.failedInvoices.invoices.length > 0) {
                this.isShowHeader = true
            }
            else {
                this.isShowHeader = false
            }
        },

        paymentCollectResponse: function (data) {

            this.isShowHeader = false
        },
    },

    methods: {
        ...mapActions([
            "getFailedInvoices",
        ]),

        payOutstandingInvoice() {
            this.$refs.processFailedModal.show();

        },
    }
}
</script>